import { render, staticRenderFns } from "./GroupedCheckboxFacet.vue?vue&type=template&id=5610b381&"
import script from "./GroupedCheckboxFacet.vue?vue&type=script&lang=js&"
export * from "./GroupedCheckboxFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports